"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const useAppUid_1 = require("../../../webapp/behaviours/useAppUid");
const WebsiteDetailWrapper = styled_components_1.default.div `
  display: flex;
`;
const StyledLink = styled_components_1.default.a `
  font-size: 1rem;
  font-weight: 500;
  text-align: center;
  width: 50%;
  padding: 12px 16px;
  margin: 24px auto auto;
  border-radius: 4px;
  background-color: ${props => props.theme.palette.mainAppColor.main};
  color: ${props => props.theme.palette.mainAppColor.contrastText};
`;
const withHttp = (url) => (!/^https?:\/\//i.test(url) ? `http://${url}` : url);
const WebsiteModalContent = (props) => {
    const transformBookingUrl = (0, useAppUid_1.useAppUid)();
    const href = transformBookingUrl(withHttp(props.websiteData.url));
    return (react_1.default.createElement(WebsiteDetailWrapper, { className: "website-page" },
        react_1.default.createElement(StyledLink, { href: href, target: "_blank", rel: "noopener noreferrer" }, i18n_js_1.default.t('open_external_website'))));
};
exports.default = WebsiteModalContent;
